module.exports = __webpack_public_path__ + "static/img/7.41127f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/7.jpg
// module id = QYIH
// module chunks = 1